import React, { useState } from 'react';
import { Tab, Nav } from 'react-bootstrap';

import './tracksideexperiances.scss';
import placeholder from "~/assets/placeholder-image.svg";
import Translate from "~/Components/ContentTranslate/Translate";
import TextTranslate from '../../Components/TextTranslate/TextTranslate';

export default function TracksideExperiances ({data}) {

    const [activeTab, setActiveTab] = useState(0);

    const imageUrl = data[activeTab]?.image?.download_url || placeholder;

	return (
		<div className="trackside-experiances text-left">
			<div className="container p-0">

                <div className="background" style={{backgroundImage: `url(${imageUrl})`}} />

				<div className="content-limit bookmark row mx-auto">
					<Tab.Container defaultActiveKey={0}>

							<div className="bookmark__nav">
								<Nav variant="pills" className="flex-column">
                                    {data.map((exp, key) => (
                                        <Nav.Item key={key}>
                                            <Nav.Link eventKey={key}
                                                      onSelect={() => setActiveTab(key)}>
                                                <Translate model={exp} field="name" />
                                            </Nav.Link>
                                        </Nav.Item>
                                    ))}
								</Nav>
							</div>
							<Tab.Content>

                                {data.map((exp, key) => (
                                    <Tab.Pane key={key} className="row" eventKey={key}>
                                        <div className="bookmark__main col-md-6 col-12">
                                            <h4 className="text-headline"><Translate model={exp} field="name" /></h4>
                                            <p className="pre-line"><Translate model={exp} field="description" /></p>
                                        </div>
                                        <div className="useful-info col-md-6 col-12">
                                            <h4 className="text-headline"><TextTranslate name="word-useful-information" fallback="Useful Information"/></h4>
                                            <p className="pre-line"><Translate model={exp} field="info" /></p>

                                            {false && <ul>
                                                <li><p>Access to the Viewing Gallery is limited to 4 personnel during one session.</p></li>
                                                <li><p>Average rotations through the viewing gallery are approximately 10-15 minutes.</p></li>
                                                <li><p>No photos can be taken from the viewing gallery due to the privileged position directly behind the cars.</p></li>
                                            </ul>}
                                        </div>
                                    </Tab.Pane>
                                ))}
							</Tab.Content>
					</Tab.Container>
				</div>
			</div>
		</div>
	)
}
